import { Fragment, useState } from 'react';

import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

interface Props {
  children: React.ReactNode;
  popoverContent: React.ReactNode;
}

const NavGroupPopover = ({ children, popoverContent }: Props) => {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <Popover
      className="relative cursor-pointer"
      onMouseEnter={() => setIsShowing(true)}
      onMouseLeave={() => setIsShowing(false)}
    >
      {({ open }) => (
        <>
          <Popover.Button
            className={` ${open ? '' : ''} inline-flex items-center rounded-wt px-2 py-2 hover:bg-black/5 focus:outline-none focus-visible:ring-2`}
          >
            {children}
            <ChevronDownIcon
              className={`${open ? '' : ''} ml-2 h-3 w-3 text-wt-text-on-tertiary transition duration-150 ease-in-out`}
              aria-hidden="true"
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            show={isShowing}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Popover.Panel className="absolute left-0 right-0 mt-2 min-w-36 origin-top-right rounded-md bg-white bg-wt-tertiary shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="overflow-hidden rounded-lg ring-1 ring-black/5">{popoverContent}</div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default NavGroupPopover;
